// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__6zzw8","iframeContainer":"styles_iframeContainer__JWQln"};